module.exports = __webpack_public_path__ + "static/media/bb-logo-original.f29e73b8.svg";